import SchemaForm from '@/components/_common/SchemaForm/SchemaForm';
import PolarisIcon from '@/components/_common/PolarisIcon';
import { FileManagerInventoryFile, OrderJobAsset } from '@/redux/slices/slice_types';
import { Box, Button, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import axios from '../../../_utils/axios';
import { Modal } from '../../_common';
import { useToast } from '../../_common/Toast';
import FileBrowser from './FileBrowser';
import PendingAssetDisplay from './PendingAssetDisplay';
import SelectedFileDisplay from './SelectedFileDisplay';
import { clearForwardLocations, setHomePath } from '@/redux/slices/fileManagerSlice';
import { getData } from '@/redux/slices/dataTableSlice';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { selectLastOpenedPendingAssetLoaction } from '@/redux/selectors/fileManagerSelectors';
import {styled} from "@mui/system";

type LinkAssetSelectionModalProps = {
  data: OrderJobAsset;
  title?: string;
  onClose: () => void;
};

const LinkAssetSelectionModal = ({ data, title, onClose }: LinkAssetSelectionModalProps) => {
  const { success, error } = useToast();
  const { id } = data;
  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState<any>(null);
  const dispatch = useAppDispatch();
  const lastPath = useAppSelector(selectLastOpenedPendingAssetLoaction);

  useEffect(() => {
    if (!lastPath) {
      dispatch(setHomePath());
      dispatch(clearForwardLocations());
    }
  }, []);

  const handleFileSelection = (file: FileManagerInventoryFile) => {
    setSelectedFile(file);
  };

  const handleBack = () => {
    setSelectedFile(null);
  };

  const onSubmit = (data: any) => {
    setLoading(true);
    axios
      .post(`/core/jobs/assets/${id}/link/`, {
        key: selectedFile.key,
        origin_name: selectedFile.origin_name,
        origin_slug: selectedFile.origin_slug,
        ...data.formData
      })
      .then((res) => {
        if (!res.data?.data) {
          throw new Error();
        }
        success('Successfully linked file.');
        dispatch(getData());
        onClose();
      })
      .catch((err) => error(err.response?.data?.message || 'Failed to register file.'))
      .finally(() => setLoading(false));
  };

  return (
    <StyledModal open onClose={onClose} title={title || 'Link File'} loading={loading} icon={<PolarisIcon icon="link" />}>
      <PendingAssetDisplay pendingAsset={data} />
      {selectedFile ? (
        <>
          <SelectedFileDisplay selectedFile={selectedFile} />
          <Box sx={{ mt: 7 }}>
            <SchemaForm schema={data.schema || {}} onSubmit={onSubmit}>
              <Grid container sx={{ mt: 3 }}>
                <Button variant="outlined" startIcon={<PolarisIcon icon="back" />} onClick={handleBack}>
                  Back
                </Button>
                <Button variant="text" color="default" onClick={onClose} sx={{ ml: 'auto', mr: 1 }}>
                  Cancel
                </Button>
                <Button type="submit" color="primary" variant="contained">
                  Link File
                </Button>
              </Grid>
            </SchemaForm>
          </Box>
        </>
      ) : (
        <FileBrowser onFileSelect={handleFileSelection} />
      )}
    </StyledModal>
  );
};

export default LinkAssetSelectionModal;

const StyledModal = styled(Modal)(() => ({
  '& .MuiIconButton-root[data-testid="new-folder-btn"]': {
    display: 'none',
  }
}));